import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { Button, Modal } from 'react-bootstrap'
import { isValidIpAddress } from '../common/utilities/Validations';
import { GENERIC_REQUEST,ADD_UPDATE, getApiPath, GENERIC_PAGINATED_KEY_VALUE_LIST, MONGO_COMMANDS } from '../../api/ApiConst';

import apiCaller from "../../api/ApiCaller";
import textUtils from '../common/utilities/TextUtils';
import { toast } from 'react-toastify';

const RequestAddEdit = (props) => {
    const requestTypeOptions = [
        { label: "Get", value: "GET" },
        { label: "Head", value: "HEAD" },
        { label: "Post", value: "POST" },
        { label: "Put", value: "PUT" },
        { label: "Patch", value: "PATCH" },
        { label: "Delete", value: "DELETE" },
        { label: "Options", value: "OPTIONS" },
        { label: "Trace", value: "TRACE" },
    ];
    const responseTypeOptions = [
        { label: "OBJECT VIEW", value: "OBJECT_VIEW" },
        { label: "SINGLE DATA VIEW", value: "SINGLE_DATA_VIEW" },
        { label: "TABLE VIEW", value: "TABLE_VIEW" }
       
    ];
    const [apiAddressListArr, setApiAddressListArr] = useState("");
    const [requestTypeKeyValue, setRequestTypeKeyValue] = useState("");
    const [responseTypeKeyValue, setResponseTypeKeyValue] = useState("");
    const [commandIdKeyValue, setCommandIdKeyValue] = useState("");
    const [commandIdList, setCommandIdList] = useState([]);
    const [requestObj, setRequestObj] = useState({
        id: "",
        commandId: "",
        name: "",
        description: "",
        type: "",
        cashed: false,
        pageable: false,
        ipBounded: false,
        ipAddressList: [],
        authenticated: false,
        responseType:""
    })

    // Close Request Create/Update Model Box
    const toggle = () => {
        props.close();
    }

    //Text Change Event for Input, text, Select
    const handleTextChange = (e, type, id) => {
        if (type === "checkbox") {
            if (id === "ipBounded" && e.target.checked === false) {
                setRequestObj(prev => ({ ...prev, [e.target.id]: e.target.checked, ipAddressList: [] }));
                setApiAddressListArr("");
            } else {
                setRequestObj(prev => ({ ...prev, [e.target.id]: e.target.checked }));
            }
        } else if (type === "text") {
            setRequestObj(prev => ({ ...prev, [e.target.id]: e.target.value }));
        } else if (type === "select") {
            if (id === "commandIdList") {
                setCommandIdKeyValue(e)
                setRequestObj(prev => ({ ...prev, commandId: e.value }))
            }
            if (id === "type") {
                setRequestTypeKeyValue(e);
                setRequestObj(prev => ({ ...prev, type: e.value }))
            }
            if (id === "responseType") {
                setResponseTypeKeyValue(e);
                setRequestObj(prev => ({ ...prev, responseType: e.value }))
            }
        }
    }

    // Add Valid IP address 
    const handleAddIpAddresses = (e) => {
        var flag = isValidIpAddress(e.target.value)
        if (flag) {
            let _requestObj = { ...requestObj }
            _requestObj.ipAddressList.push(e.target.value)
            setRequestObj(_requestObj);
            setApiAddressListArr("");
        }
    }

    // Remove Selected Ip Address
    const handleRemoveIpAddress = (data, i) => {
        let _requestObj = { ...requestObj }
        _requestObj.ipAddressList = _requestObj.ipAddressList.filter(v => v !== data);
        setRequestObj(_requestObj);
        // _requestObj.ipAddressList.push(e.target.value)
    }

    useEffect(() => {
        if (props.object != null) {
            setRequestObj(props.object);
            if (props.object.type !== "") {
                setRequestTypeKeyValue({
                    label: props.object.type,
                    value: props.object.type
                });
                setCommandIdKeyValue({
                    label: props.object.commandId,
                    value: props.object.commandId
                })
            } else {
                setRequestTypeKeyValue("");
                setCommandIdKeyValue("");
            }
        }

        if (props.show) {
            getMongoCommandList()
        }
    }, [props.object]);

    const getMongoCommandList = () => {
        var jsonRequest = {
            "page": 0,
            "size": 200,
            searchFilters: [],
            sortRules: [],
        };
        apiCaller.callPostApi(getApiPath(MONGO_COMMANDS, GENERIC_PAGINATED_KEY_VALUE_LIST), jsonRequest, {}, (response) => {
            const options = []
            response.data.map((d) => {
                options.push({
                    value: d.key,
                    label: d.value,
                })
            });
            setCommandIdList(options);
        }, (error) => {
            console.error(error);
        });

    }

    // Create Request data
    const handleCreateRequest = () => {
        let requestPayloadObj = requestObj;
        if ((textUtils.isEmpty(requestPayloadObj.name, "Name", true)) ||
            textUtils.isEmpty(requestPayloadObj.type, "Type", true) ||
            (textUtils.isEmpty(requestPayloadObj.description, "Description", true)) ||
            (textUtils.isEmpty(requestPayloadObj.commandId, "Command", true)) ||
            ((requestPayloadObj.ipBounded) && (textUtils.isEmpty(requestPayloadObj.ipAddressList.length, "IP Address List", true)))
        ) {
            return false;
        }

        let url = getApiPath(GENERIC_REQUEST, ADD_UPDATE);
        apiCaller.callPostApi(url, requestPayloadObj, {}, (response) => {
            toast.success("Request Created Successfully");
            toggle();
            props.successCallBack();
        }, (error) => {
            // toast.error(error.response.data.message);
        })
    }

    return (
        <>
            <Modal show={props.show} onHide={toggle} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Create Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row mb-3">
                        <div className="col-lg-6">
                            <label>Name *</label>
                            <input type="text" className="form-control input-default w-100"
                                id="name"
                                placeholder='Name'
                                onChange={(e) => handleTextChange(e, e.target.type, e.target.id)}
                                value={requestObj.name}
                            />
                        </div>
                        <div className="col-lg-6">
                            <label>Type *</label>
                            <Select
                                options={requestTypeOptions}
                                value={requestTypeKeyValue}
                                id="type"
                                onChange={(e) => handleTextChange(e, "select", "type")}
                                className="react-select-container"
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Description *</label>
                            <input type="text" className="form-control input-default w-100"
                                id="description"
                                placeholder='Description'
                                onChange={(e) => handleTextChange(e, e.target.type, e.target.id)}
                                value={requestObj.description}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Response Type*</label>
                            <Select
                                options={responseTypeOptions}
                                value={responseTypeKeyValue}
                                id="responseType"
                                onChange={(e) => handleTextChange(e, "select", "responseType")}
                                className="react-select-container"
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Command *</label>
                            <Select
                                options={commandIdList}
                                value={commandIdKeyValue}
                                id="commandIdList"
                                onChange={(e) => handleTextChange(e, "select", "commandIdList")}
                                className="react-select-container"
                            />
                        </div>
                    </div>
                    <div className="form-group d-flex mb-3">
                        <div className="me-5">
                            <input
                                type="checkbox"
                                name="cashed"
                                id="cashed"
                                checked={requestObj.cashed}
                                onChange={(e) => handleTextChange(e, e.target.type, e.target.id)}
                            />
                            <label className='ms-2'>Cached</label>
                        </div>
                        <div className="me-5">
                            <input
                                type="checkbox"
                                name="pageable"
                                id="pageable"
                                checked={requestObj.pageable}
                                onChange={(e) => handleTextChange(e, e.target.type, e.target.id)}
                            />
                            <label className='ms-2'>Pageable</label>
                        </div>
                        <div className="me-5">
                            <input
                                type="checkbox"
                                name="ipBounded"
                                id="ipBounded"
                                checked={requestObj.ipBounded}
                                onChange={(e) => handleTextChange(e, e.target.type, e.target.id)}
                            />
                            <label className='ms-2'>IP Bounded</label>
                        </div>
                        <div className="me-5">
                            <input
                                type="checkbox"
                                name="authenticated"
                                id="authenticated"
                                checked={requestObj.authenticated}
                                onChange={(e) => handleTextChange(e, e.target.type, e.target.id)}
                            />
                            <label className='ms-2'>Authenticated</label>
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>IP Address List </label>
                            <div className={`addressList mt-3 ${!requestObj.ipBounded && "disabled"}`}>
                                {requestObj.ipAddressList.length > 0 && requestObj.ipAddressList.map((data, i) =>
                                    <button className='removableButton'>{data} <i className="fa fa-times" onClick={() => handleRemoveIpAddress(data, i)}></i></button>
                                )}
                                <input
                                    type="text"
                                    className="form-control input-default w-auto d-inline"
                                    id="ipAddressList"
                                    placeholder={requestObj.ipAddressList.length === 0 && 'IP Address List'}
                                    value={apiAddressListArr}
                                    disabled={!requestObj.ipBounded}
                                    onChange={event => { setApiAddressListArr(event.target.value) }}
                                    onKeyPress={event => {
                                        if (event.key === 'Enter') {
                                            handleAddIpAddresses(event)
                                        }
                                    }}
                                />
                            </div>
                            <small id="passwordHelpBlock" className="form-text text-muted">
                                *If you checked the IP Bounded then you have add IP Address List.
                            </small>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary"
                        onClick={handleCreateRequest}
                    >
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default RequestAddEdit